<template>
  <Container>
    <FadeIn class="pt-16 lg:pt-24 pb-6 lg:pb-24 lg:-mr-[80px] xl:-mr-[100px]">
      <div class="text-gray-900">
        <figure>
          <blockquote class="quote">
            {{ content.quote }}
          </blockquote>
          <figcaption 
          class="quote__author mt-4" 
          v-html="content.author" 
          v-interpolation></figcaption>
        </figure>
      </div>
    </FadeIn>
  </Container>
</template>

<script setup>
const props = defineProps({
  content: {
    type: Object,
    required: true,
  }
})
</script>

<style lang="scss">
@import '@/assets/scss/_vars.scss';
.quote {
  font-size: 1.45rem;
  font-weight: 700;
  line-height: 120%;
  letter-spacing: -.01em;
  @media (min-width: $breakpoint) {
    font-size: 2.225rem;
    line-height: 110%;
  }
  @media (min-width: $breakpoint-lg) {
    font-size: 2.5rem;
    letter-spacing: -.02em;
  }
}

.quote__author {
  font-size: 1rem;
  font-weight: 700;
  line-height: 130%;
  letter-spacing: 0;
  @media (min-width: $breakpoint-lg) {
    font-size: 1.125rem;
  }
  a {
    text-decoration: underline;
  }
}
</style>